import { createSlice } from '@reduxjs/toolkit';

import {
    addTramitDocType,
    deleteForceDeletableTramitAttachment,
    deleteTramitAttachment,
    manualSignTramitAttachment,
    manualSignTramitAttachmentByAjuntament,
    setSelectedTramit,
    updateTramit,
    updateTramitAttachment,
    uploadTramitAttachmentByDocNumber,
    uploadTramitAttachmentById,
} from './thunkActions/tramit';
import { ITramitState } from './types';

const getInitialState = (): ITramitState => ({
    selectedTramit: null,
    isLoading: false,
    isAttachmentProcessing: false,
});

const tramitSlice = createSlice({
    name: 'tramit',
    initialState: getInitialState(),
    reducers: {
        /** Reducer to set selectedTramit from payload */
        setSelectedTramitSync: (state, action) => ({ ...state, selectedTramit: action.payload }),
    },
    extraReducers: builder => builder

        .addCase(manualSignTramitAttachmentByAjuntament.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(manualSignTramitAttachmentByAjuntament.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachmentByAjuntament.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(manualSignTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(updateTramit.pending, state => ({ ...state, isLoading: true }))

        .addCase(updateTramit.rejected, state => ({ ...state, isLoading: false }))

        .addCase(updateTramit.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload, isLoading: false }))

        .addCase(addTramitDocType.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(addTramitDocType.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(addTramitDocType.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentByDocNumber.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(uploadTramitAttachmentByDocNumber.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentByDocNumber.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentById.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(uploadTramitAttachmentById.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentById.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(updateTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(updateTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(updateTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(deleteTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(deleteTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(deleteTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(deleteForceDeletableTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(deleteForceDeletableTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(deleteForceDeletableTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload.selectedTramit, isAttachmentProcessing: false }))

        .addCase(setSelectedTramit.pending, state => ({ ...state, isLoading: true }))

        .addCase(setSelectedTramit.rejected, state => ({ ...state, isLoading: false }))

        .addCase(setSelectedTramit.fulfilled, (state, action) => ({ ...state, selectedTramit: action.payload, isLoading: false })),
});

export const { setSelectedTramitSync } = tramitSlice.actions;

export const tramit = tramitSlice.reducer;
